import { useNavigate } from 'react-router'

import { Header } from '@/components/shared/header'
import { PageTabs } from '@/components/shared/page-tabs'
import { PATHS } from '@/routes/paths'

import { DownloadQueueTab } from './download-queue-tab'
import { NotebooklmJobsTab } from './notebooklm-jobs-tab'
import { NotificationLogTab } from './notification-log-tab'

export function NotificationsPage() {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col h-dvh">
      <Header title="通知" onClose={() => navigate(PATHS.HOME)} />

      <PageTabs
        defaultTab="log"
        className="flex-1 min-h-0 flex flex-col"
        contentClassName="flex-1 overflow-hidden flex flex-col"
        tabs={[
          { value: 'log', label: '通知ログ', content: <NotificationLogTab /> },
          { value: 'queue', label: 'ダウンロードキュー', content: <DownloadQueueTab /> },
          { value: 'notebooklm', label: 'NotebookLM', content: <NotebooklmJobsTab /> },
        ]}
      />
    </div>
  )
}
